// stompService.js
import SockJS from "sockjs-client";
import { Client } from "@stomp/stompjs";
import { CHAT } from "common/config-api";

let stompClient = null;
const subscribers = [];

// userVisitNotification
const userVisitNotiSocket = (onMessage) => {
  if (onMessage && typeof onMessage === "function") {
    subscribers.push(onMessage);
  }

  if (stompClient && stompClient.connected) return;

  const socket = new SockJS(`${CHAT.MSG_URL}`);
  stompClient = new Client({
    webSocketFactory: () => socket,
    reconnectDelay: 5000,
    onConnect: () => {
      console.log("WebSocket connected");

      stompClient.subscribe("/api/topic/notifications", (message) => {
        subscribers.forEach((handler) => handler(message.body));
      });
    },
  });

  stompClient.activate();
};

// posDataReceiveAndReviewToGuest
const posPreviewForGuestSocket = (onMessage) => {
  if (onMessage && typeof onMessage === "function") {
    subscribers.push(onMessage);
  }

  if (stompClient && stompClient.connected) return;

  const socket = new SockJS(`${CHAT.MSG_URL}`);
  stompClient = new Client({
    webSocketFactory: () => socket,
    reconnectDelay: 5000,
    onConnect: () => {
      console.log("WebSocket connected");

      stompClient.subscribe("/api/topic/billing", (message) => {
        subscribers.forEach((handler) => handler(message.body));
      });
    },
  });

  stompClient.activate();
};

const publishMessage = (destination, body) => {
  if (stompClient && stompClient.connected) {
    stompClient.publish({ destination, body });
  } else {
    console.warn("WebSocket is not connected yet");
  }
};

const isConnected = () => stompClient?.connected;

export { posPreviewForGuestSocket, userVisitNotiSocket, publishMessage, isConnected };
